// =============================================================================
// We import all required libraries here, so that they get bundled
// =============================================================================
// Also determines the order of the bundle export, so we definitely
// want 'window.angular' be defined before anything else:
import 'jquery'; // must be first!
import 'angular'; // must be second!
import 'angular-cookies';
import 'angular-route';
import 'angular-sanitize';
import 'angular-translate';
import 'angular-ui-bootstrap';
import 'angular-ui-router';
import 'bootstrap';
import 'jsoneditor/dist/jsoneditor-minimalist';
import { registerAutoFocus } from './jquery/register-auto-focus';
import { registerOrganizationSwitch } from './shared/organization-switch';
import { AppModule } from './app/app.module';
registerAutoFocus();
registerOrganizationSwitch();
// Do NOT add an explicit module bootstrapping invocation
// anywhere, but instead, just keep the AppModule as an
// referred/used value here, so it will be included in the
// webpack-bundle, so:
//
// - in app.module.ts
//    we DEFINE the 'snapaddyAnalytics' module
// - in page-head.html
//    we BOOTSTRAP it via 'ng-app="snapaddyAnalytics"'
//    attribute on the <html> tag
//
// Magic! 🧙
// oxlint-disable-next-line no-void
void AppModule;
